import { useTranslate } from "@similarweb/i18n-provider";
import { IconButton } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import { NoTouchPurchaseSummaryModalTitleContainer } from "app/components/no-touch-purchase-modal/summary-modal/title/StyledNoTouchPurchaseSummaryModalTitle";
import { NO_TOUCH_PURCHASE_TRANSLATIONS } from "app/components/no-touch-purchase-modal/translations";
import type { AddonTypeName } from "app/contexts/AddonStateContext/const";

interface INoTouchPurchaseSummaryModalTitleProps {
    addonType: AddonTypeName;
    onClose: () => void;
    isOneClickSmallTest: boolean;
}

export const NoTouchPurchaseSummaryModalTitle = ({
    addonType,
    onClose,
    isOneClickSmallTest,
}: INoTouchPurchaseSummaryModalTitleProps) => {
    const { translate } = useTranslate();

    const { title, titleShort } = NO_TOUCH_PURCHASE_TRANSLATIONS.summary[addonType];
    const titleKey = isOneClickSmallTest ? titleShort : title;

    return (
        <NoTouchPurchaseSummaryModalTitleContainer>
            <Text fontVariant={isOneClickSmallTest ? "h5_2" : "h5"}>{translate(titleKey)}</Text>
            <IconButton
                type="flat"
                onClick={onClose}
                iconName="clear"
                placement="left"
                iconSize="sm"
            />
        </NoTouchPurchaseSummaryModalTitleContainer>
    );
};
